import React from "react";
import { Box, Typography, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const ErrorState = ({ error, onRetry }) => (
    <Box py={3} textAlign="center">
        <Typography color="error.main" fontSize={14} fontWeight={600} mb={1}>
            Erreur de chargement
        </Typography>
        <Typography color="text.secondary" fontSize={12} mb={2}>
            {error}
        </Typography>
        {onRetry && (
            <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={onRetry}
                startIcon={<RefreshIcon />}
                sx={{ textTransform: "none", borderRadius: 2 }}
            >
                Réessayer
            </Button>
        )}
    </Box>
);

export default ErrorState;
